import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedUiModule } from '@digital-platform/shared/ui';
import { SharedUiMaterialModule } from '@digital-platform/shared/ui-material';
import { RadioSelectComponent } from './radio-select/radio-select.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedUiModule,
    SharedUiMaterialModule
  ],
  declarations: [RadioSelectComponent],
  exports: [RadioSelectComponent]
})
export class DisposalSitesUiModule {}
